import { render, staticRenderFns } from "./DossierMedicalManagement.vue?vue&type=template&id=c8ff3696&scoped=true"
import script from "./DossierMedicalManagement.vue?vue&type=script&lang=js"
export * from "./DossierMedicalManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ff3696",
  null
  
)

export default component.exports